import {FormInstance} from 'antd/es/form';
import {Store} from 'antd/es/form/interface';
import {
    omit, omitBy, setWith,
} from 'lodash-es';

import {isConditionValueUnnecessary} from 'components/@common/widgets/custom-table/table-column-menu/utils';
import {TFieldPath} from 'components/report-configuration/report-configuration.types';
import {TStateSetter} from 'shared/types/generics';

export const groupArrayByKey = (array: any[], key: string) => Object.fromEntries(
    array.map(element => [element[key], omit(element, key)]),
);

export const compactObject = (object?: Object) => {
    if (!object) return object;
    return omitBy(object, v => !v);
};

export const transformSingleValidationResultWithError = (errorResult: any) => {
    const errorsObject = {};
    const errorFields = errorResult?.errorFields ?? [];
    errorFields.forEach((fieldError: any) => {
        if (fieldError.name && fieldError.errors) {
            const {name, errors} = fieldError;
            setWith(errorsObject, name, errors, Object);
        }
    });
    return errorsObject;
};

// для подсветки формы в модалке, в которой ошибка
export const transformValidationResultsWithErrors = (errorsResults: PromiseSettledResult<{
    formName: string;
    result: Store;
}>[]) => {
    // Переформатирование стандартных результатов валидации к объекту
    // {[путь]: ошибка}
    const errorsObject = {};
    (errorsResults ?? [])
        .filter(res => res.status === 'rejected')
        .map((res: any) => res.reason?.errorFields)
        .forEach(fieldsErrors => {
            fieldsErrors.forEach((fieldError: any) => {
                if (fieldError.name && fieldError.errors) {
                    const {name, errors} = fieldError;
                    setWith(errorsObject, name, errors, Object);
                }
            });
        });
    return errorsObject;
};

interface IDisableModalFormatValueInputArgs {
    value: any;
    name: string | number;
    form: FormInstance;
    valueInputFieldPath: TFieldPath;
    disabledValueInputs: Record<string, boolean>;
    setDisabledValueInputs: TStateSetter<Record<string, boolean>>;
}

export const disableModalFormatValueInput = ({
    value,
    name,
    form,
    valueInputFieldPath,
    disabledValueInputs,
    setDisabledValueInputs,
}: IDisableModalFormatValueInputArgs) => {
    const shouldDisableValueInput = isConditionValueUnnecessary(value?.lookupCode);
    const isCurrentValueInputDisabled = Object.keys(disabledValueInputs).includes(String(name));

    if (shouldDisableValueInput && !isCurrentValueInputDisabled) {
        setDisabledValueInputs({
            ...disabledValueInputs,
            [name]: true,
        });
        form.setFields([
            {name: valueInputFieldPath, value: undefined},
        ]);
    } else if (isCurrentValueInputDisabled && !shouldDisableValueInput) {
        setDisabledValueInputs(prev => omit(prev, name));
        form.resetFields([valueInputFieldPath]);
    }
};
